import { forwardRef, memo, useEffect, useRef } from "react"
import { gsap } from "gsap"

const EnvidoPopUpMessage = forwardRef(({ envidoDetails, onClose }, ref) => {

    const containerRef = useRef()

    useEffect(() => {
        if (!containerRef.current) return

        // ENTER animation
        gsap.fromTo(
            containerRef.current,
            { scale: 0, opacity: 0 },
            { scale: 1, opacity: 1, duration: 0.5, ease: "back.out(1.7)" }
        )

        // AUTO CLOSE after 5s
        const timer = setTimeout(() => {
            gsap.to(containerRef.current, {
                scale: 0,
                opacity: 0,
                duration: 0.5,
                ease: "power2.in",
                onComplete: onClose
            })
        }, 5000)
        
        return () => clearTimeout(timer)

    }, [onClose])

    return (
        <div className='truco-envido-container'>
            <div ref={containerRef} className='truco-envido-outer-box'>
                <div className='truco-envido-inner-box'>

                    <h1 className="truco-envido-title">ENVIDO</h1>

                    <div className='truco-envido-details'>
                        <span className='truco-envido-player-details'>
                            Your Envido points:
                            <span>{envidoDetails?.playerEnvidoPoints || 0}</span>
                        </span>

                        <span className='truco-envido-player-details'>
                            Opponent's Envido points:
                            <span>{envidoDetails?.opponentEnvidoPoints || 0}</span>
                        </span>

                        <span className='truco-envido-winner-details'>
                            Winner:
                            <span>{envidoDetails?.winnerName || "N/A"}</span>
                        </span>
                    </div>

                </div>
            </div>
        </div>
    )
})

export default memo(EnvidoPopUpMessage)